import React, { Component } from 'react';
import { connect } from 'react-redux';

import axios from "axios";
import moment from "moment";
import { debounce } from "lodash";
import { withRouter, Link } from 'react-router-dom'

import { LoadingIcon } from '../Common/Loading_Icon';
import { setUserSession } from "../../Actions/userSessionActions";
import { registrationClose, registrationCheckmark, registrationCheckmarkBlue } from '../Common/Buttons/Icons';
import { Trans, Translation } from 'react-i18next';
import i18n from '../../i18n';

class Signup extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.submitSignup = debounce(this.submitSignup.bind(this), 500);
        this.createEulaMarkup = this.createEulaMarkup.bind(this);

        this.state = {
            loading_page: true,
            errors: {email: null, terms: false},
            form_details: {},
            signup_form: {first_name: "", last_name: "", company: "", title: "", email: "", password: "", password_confirmation: "", phone: "", invitation: "", terms: null, updates: true, language: ""},
            colours: {red: "#D55656", green: "#42B53A", grey: "#919EAB"}
        };
    }

    componentDidMount() {        
        document.title = "Signup - FleetXPress"
        var self = this;

        axios.get('/ajax/signup/' + this.props.match.params.invite_id)
        .then((response) => {

            this.state.signup_form.first_name = response?.data.view.first_name;
            this.state.signup_form.last_name = response?.data.view.last_name;
            this.state.signup_form.email = response?.data.view.email;
            this.state.signup_form.title = response?.data.view.title;
            this.state.signup_form.company = response?.data.view.company;
            this.state.signup_form.invitation = response?.data.view.invite;
            this.state.signup_form.language = response?.data.view.language;
            
            if (response?.data.view.language !== "English") {
                var language_code = 'fr';

                i18n.changeLanguage(language_code)
                moment.locale(language_code);
            }

            self.setState({
                form_details: response?.data.view,
                loading_page: false,
            })
        })
        .catch(function(error) {
            //handle error
            if(error.response?.status == 401 || error.response?.status == 400){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }
    
    submitSignup(e) {
        //Ensure no page refresh on submit
        e.preventDefault();
        var self = this;
        var userSessionObj = self.props.userSession;
        var signup_form = this.state.signup_form
        var password = this.state.signup_form.password
        var errors = this.state.errors
        if (password && password.length > 7 && /[A-Z]/.test(password) && /[0-9]/.test(password) && /[a-z]/.test(password) && /[!@#$%*?&]/.test(password) && password === this.state.signup_form.password_confirmation) {
            if (! (signup_form.email)) {
                errors['email'] = '*Email is invalid'
                this.setState({
                    errors: errors
                })
            } else if(! this.state.signup_form.terms) {
                errors['terms'] = true
                this.setState({
                    errors: errors
                })
            } else {
                axios({
                    method: 'post',
                    url: '/ajax/signup',
                    data: self.state.signup_form,
                    config: { headers: {'Content-Type': 'multipart/form-data' }}
                })
                .then((response) => {
                    self.props.dispatch(setUserSession(response?.data.user))
                    self.props.history.push('/roleselection')
                    window.location.reload(true);
                })
                .catch(function(error) {
                    //handle error
                    if(error.response?.status == 401 || error.response?.status == 400){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";

                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });

                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
            }
        }
    }

    createEulaMarkup(html_text) {
        return {__html: html_text}
    }

    //Whenever an input is changed, will call this function and set the corresponding state variable to the input to be used for logging in
    //Useful for any component with a form in it
    handleChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        var signup_form = this.state.signup_form;
        signup_form[name] = value;

        this.setState({
            signup_form: signup_form,
            errors: {email: null, password: null, password_confirmation: null, terms: false},
        });
    }
    
    render() {
        var password = this.state.signup_form.password

        if(!this.state.loading_page) {
            return (
                <div className = "registration-container">
                    <div className="registration-navbar">
                        <img src="images/DVMS_Logo_White.svg" />
                    </div>
                    <div className="registration-signup-card">
                        <div className="registration-half">
                            <div className="registration-header">
                                <div style={{fontSize: "18px"}}>
                                    <Trans>FleetXPress is the ultimate resource to book vehicles from various fleets</Trans>.
                                </div>
                            </div>
                            <div className="registration-signup-box">
                                <div className="signup-header-text" style={{display: 'flex'}}>
                                    <span style={{textAlign: 'center', margin: '0 auto'}}><Trans>Enter your personal details to get started</Trans>.</span>
                                </div>
                                <div className="flex-row">
                                    <span style={{marginRight: "5px", width: "50%"}}>
                                        <Translation>
                                            {
                                                (t, {i18n}) => <input className={"registration-input" + (this.state.signup_form.first_name ? " active" : "")} placeholder={t("First Name")} name="first_name" value={this.state.signup_form.first_name} onChange={this.handleChange} ></input>
                                            }
                                        </Translation>
                                    </span>
                                    <span style={{width: "49%"}}>
                                        <Translation>
                                            {
                                                (t, {i18n}) => <input className={"registration-input" + (this.state.signup_form.last_name ? " active" : "")} placeholder={t("Last Name")} name="last_name" value={this.state.signup_form.last_name} onChange={this.handleChange} ></input>
                                            }
                                        </Translation>
                                    </span>
                                </div>
                                <div className="flex-row">
                                    <span style={{marginRight: "5px", width: "50%"}}>
                                        <Translation>
                                            {
                                                (t, {i18n}) => <input className={"registration-input" + (this.state.signup_form.company ? " active" : "")} placeholder={t("Company")} name="company" value={this.state.signup_form.company} onChange={this.handleChange}></input>
                                            }
                                        </Translation>
                                    </span>
                                    <span style={{width: "49%"}}>
                                        <Translation>
                                            {
                                                (t, {i18n}) => <input className={"registration-input" + (this.state.signup_form.title ? " active" : "")} placeholder={t("Title")} name="title" value={this.state.signup_form.title} onChange={this.handleChange}></input>
                                            }
                                        </Translation>
                                        
                                    </span>
                                </div>
                                <div className="flex-row">
                                    <span style={{width: "100%"}}>
                                        <input type="email" disabled className={"registration-input" + (this.state.signup_form.email ? this.state.errors.email ? " error" : " disabled" : "")} placeholder="Email" name="email" value={this.state.signup_form.email} onChange={this.handleChange}></input>
                                    </span>
                                </div>
                                <div className="flex-row" style={{marginBottom: "5px"}}>
                                    <span style={{width: "100%"}}>
                                        <Translation>
                                            {
                                                (t, {i18n}) => <input type="password" className={"registration-input" + (password ? password.length > 7 && /[A-Z]/.test(password) && /[0-9]/.test(password) && /[a-z]/.test(password) && /[!@#$%*?&]/.test(password) ? " active" : " error" : "")} placeholder={t("Password")} name="password" value={password} onChange={this.handleChange}></input>
                                            }
                                        </Translation>
                                    </span>
                                </div>
                                <div className="registration-password-confirms">
                                    <span className={"registration-password-check" + (password ? password.length > 7 ? " success" : " error" : "")} style={{marginRight: "auto"}}>
                                        {
                                            password ? 
                                                password.length > 7 ? 
                                                    <span className="password-icon">{registrationCheckmark(this.state.colours.green)}</span>
                                                :
                                                    <span className="password-icon">{registrationClose(this.state.colours.red)}</span>
                                            :
                                                <span className="password-icon">{registrationClose(this.state.colours.grey)}</span>
                                        }
                                        <span className="password-text"><Trans>At least 8 characters</Trans></span>
                                    </span>
                                    <span className={"registration-password-check" + (password ? /[A-Z]/.test(password) ? " success" : " error": "")} style={{marginRight: "10px"}}>
                                        {
                                            password ? 
                                                /[A-Z]/.test(password) ? 
                                                    <span className="password-icon">{registrationCheckmark(this.state.colours.green)}</span>
                                                :
                                                    <span className="password-icon">{registrationClose(this.state.colours.red)}</span>
                                            :
                                                <span className="password-icon">{registrationClose(this.state.colours.grey)}</span>
                                        }
                                        <span className="password-text"><Trans>At least 1 uppercase letter</Trans></span>
                                    </span>
                                </div>
                                <div className="registration-password-confirms">
                                    <span className={"registration-password-check" + (password ? /[0-9]/.test(password) ? " success" : " error": "")} style={{marginRight: "auto"}}>
                                        {
                                            password ? 
                                                /[0-9]/.test(password) ? 
                                                    <span className="password-icon">{registrationCheckmark(this.state.colours.green)}</span>
                                                :
                                                    <span className="password-icon">{registrationClose(this.state.colours.red)}</span>
                                            :
                                                <span className="password-icon">{registrationClose(this.state.colours.grey)}</span>
                                        }
                                        <span className="password-text"><Trans>At least 1 number</Trans></span>
                                    </span>
                                    <span className={"registration-password-check" + (password ? /[a-z]/.test(password) ? " success" : " error": "")} style={{marginRight: "10px"}}>
                                        {
                                            password ? 
                                                /[a-z]/.test(password) ? 
                                                    <span className="password-icon">{registrationCheckmark(this.state.colours.green)}</span>
                                                :
                                                    <span className="password-icon">{registrationClose(this.state.colours.red)}</span>
                                            :
                                                <span className="password-icon">{registrationClose(this.state.colours.grey)}</span>
                                        }
                                        <span className="password-text"><Trans>At least 1 lowercase letter</Trans></span>
                                    </span>
                        </div>
                                <div className="registration-password-confirms">
                                    <span className={"registration-password-check" + (password ? /[!@#$%*?&]/.test(password) ? " success" : " error": "")} style={{marginRight: "auto"}}>
                                        {
                                            password ? 
                                                /[!@#$%*?&]/.test(password) ? 
                                                    <span className="password-icon">{registrationCheckmark(this.state.colours.green)}</span>
                                                :
                                                    <span className="password-icon">{registrationClose(this.state.colours.red)}</span>
                                            :
                                                <span className="password-icon">{registrationClose(this.state.colours.grey)}</span>
                                        }
                                        <span className="password-text"><Trans>At least 1 of the following symbols</Trans>: ! @ # $ % * ? &</span>
                                    </span>
                                </div>
                                <div className="flex-row">
                                    <span style={{width: "100%"}}>
                                        <Translation>
                                            {
                                                (t, {i18n}) => <input type="password" className={"registration-input" + (this.state.signup_form.password_confirmation.length >= password.length && this.state.signup_form.password_confirmation ? this.state.signup_form.password_confirmation === password ? " active" : " error" : "")} placeholder={t("Confirm Password")} name="password_confirmation" value={this.state.signup_form.password_confirmation} onChange={this.handleChange}></input>
                                            }
                                        </Translation>
                                        
                                        <span style={{fontSize: "10px", color: "red", display: "ruby-text"}}>{this.state.signup_form.password_confirmation.length >= password.length && this.state.signup_form.password_confirmation && this.state.signup_form.password_confirmation !== password && "*Password must match previous entry"}</span>
                                    </span>
                                </div>
                                <div className="registration-checkboxes">
                                    <div className="checkbox-primary">
                                        <label className="checkbox-primary-label">
                                            <input type="checkbox" name="terms" onChange={this.handleChange} />
                                            <span className={"checkbox-primary-custom " + (this.state.errors.terms ? " checkbox-primary-error" : "")}></span>
                                            <span className={"checkbox-primary-text " + (this.state.errors.terms ? "error" : "")}><Trans>I agree to the</Trans> <Link className="registration-link" target="_blank" to={"/eula" + (this.state.signup_form.language ? ("?lang=" + (this.state.signup_form.language).toLowerCase().substring(0, 2)) : "")}><Trans>Terms of Use</Trans></Link> <Trans>and</Trans> <Link className="registration-link" target="_blank" to={"/privacy" + (this.state.signup_form.language ? ("?lang=" + (this.state.signup_form.language).toLowerCase().substring(0, 2)) : "")}><Trans>Privacy Policy</Trans></Link></span>
                                        </label>
                                    </div>
                                    <div className="checkbox-primary">
                                        <label className="checkbox-primary-label">
                                            <input type="checkbox" name="updates" defaultChecked={this.state.signup_form.updates} onChange={this.handleChange} />
                                            <span className={"checkbox-primary-custom " + (this.state.errors.updates ? " checkbox-primary-error" : "")}></span>
                                            <span className={"checkbox-primary-text " + (this.state.errors.updates ? "error" : "")}><Trans>I would like to receive notifications about new vehicles, fleets, drive events, and other initiatives</Trans>.</span>
                                        </label>
                                    </div>
                                </div>
                                <div 
                                    className={"registration-button-container" + (password && password.length > 7 && /[A-Z]/.test(password) && /[0-9]/.test(password) && /[a-z]/.test(password) && /[!@#$%*?&]/.test(password) && password === this.state.signup_form.password_confirmation && this.state.signup_form.email && this.state.signup_form.first_name && this.state.signup_form.last_name ? "" : " disabled")} 
                                    onClick={this.submitSignup}
                                >
                                    <span>
                                        <Trans>Continue</Trans>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="registration-half registration-info">
                            <div style={{width: "100%", display: "flex", flexWrap: "wrap", margin: "30px 0"}}>
                                <img src="images/DVMS_Logo_White.svg" style={{margin: "0 auto", width: "225px", height: "40px"}}/>
                            </div>
                            <div className="registration-signup-facts">
                                <div className="registration-fact">
                                    <span className="registration-fact-check"><img src="/images/icons/survey/Checkmark_Registration.svg"/></span>
                                    <span className="registration-fact-text"><Trans>Make or modify your bookings in seconds</Trans>.</span>
                                </div>
                                <div className="registration-fact">
                                    <span className="registration-fact-check"><img src="/images/icons/survey/Checkmark_Registration.svg"/></span>
                                    <span className="registration-fact-text"><Trans>Access multiple fleets online</Trans>.</span>
                                </div>
                                <div className="registration-fact">
                                    <span className="registration-fact-check"><img src="/images/icons/survey/Checkmark_Registration.svg"/></span>
                                    <span className="registration-fact-text"><Trans>Select the right vehicles for your needs</Trans>.</span>
                                </div>
                            </div>
                            <div className="registration-signup-companies">
                                <div className="registration-company-list" style={{padding: "0 25%"}}>
                                    <div style={{display: "flex", margin: "0 auto", width: "auto"}}>
                                        <img className="registration-company-image-1" src="/images/OEM-Logos/Black/HarleyDavidson_Logo_Black.svg" style={{marginLeft: "auto"}}/>
                                        <img className="registration-company-image-1" src="/images/OEM-Logos/Black/BMW_Logo_Black.svg" />
                                        <img className="registration-company-image-1" src="/images/OEM-Logos/Black/KIA_Logo_Black.svg" />
                                        <img className="registration-company-image-1" src="/images/OEM-Logos/Black/MINI_Logo_Black.svg" />
                                        <img className="registration-company-image-1" src="/images/OEM-Logos/Black/Infiniti_Logo_Black.svg" style={{marginRight: "auto"}}/>
                                    </div>
                                </div>
                                <div className="registration-company-list" style={{padding: "0 22%"}}>
                                    <div style={{display: "flex", margin: "0 auto", width: "auto"}}>
                                        <img className="registration-company-image-2" src="/images/OEM-Logos/Black/Subaru_Logo_Black.svg" style={{marginLeft: "auto"}}/>
                                        <img className="registration-company-image-2" src="/images/OEM-Logos/Black/Jaguar_Logo_Black.svg" />
                                        <img className="registration-company-image-2" src="/images/OEM-Logos/Black/Audi_Logo_Black.svg" />
                                        <img className="registration-company-image-2" src="/images/OEM-Logos/Black/Mitsubishi_Logo_Black.svg" />
                                        <img className="registration-company-image-2" src="/images/OEM-Logos/Black/LandRover_Logo_Black.svg" />
                                        <img className="registration-company-image-2" src="/images/OEM-Logos/Black/Nissan_Logo_Black.svg" style={{marginRight: "auto"}}/>
                                    </div>
                                </div>
                                <div style={{display: 'flex', flex: 1, justifyContent: 'flex-end', alignContent: 'flex-end', alignSelf: 'flex-end', paddingRight: '20px', marginTop: '10px', marginBottom: '5px'}}>
                                *Fleet availability varies in different markets.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <LoadingIcon />
            )
        }
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    settings: store.settings
})

export default connect(mapStateToProps,)(Signup);